import { WAIT_FOR_ACTION, ERROR_ACTION } from "redux-wait-for-action";

export const SEND_ADHOC_AUTHORIZATION = "SEND_ADHOC_AUTHORIZATION";
export const SEND_ADHOC_AUTHORIZATION_SUCCESS = "SEND_ADHOC_AUTHORIZATION_SUCCESS";
export const SEND_ADHOC_AUTHORIZATION_FAIL = "SEND_ADHOC_AUTHORIZATION_FAIL";

export const sendAuthorizationSuccess = () => ({
  type: SEND_ADHOC_AUTHORIZATION_SUCCESS
});

export const sendAuthorizationFail = () => ({
  type: SEND_ADHOC_AUTHORIZATION_FAIL
});

export const sendAdhocAuthorizationPromisify = (data, documents) => ({
  type: SEND_ADHOC_AUTHORIZATION,
  [WAIT_FOR_ACTION]: SEND_ADHOC_AUTHORIZATION_SUCCESS,
  [ERROR_ACTION]: SEND_ADHOC_AUTHORIZATION_FAIL,
  payload: { data, documents }
});
